import { Box } from "@mui/material";
import { styled } from "@mui/system";
import { Colors } from "../theme/index";

export const ModalContain = styled(Box)(() => ({
  backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent black background
  display: "flex",
  alignItems: "center", // Center the modal vertically
  justifyContent: "center", // Center the modal horizontally
  padding: "10px",
  position: "fixed",
  right: "0",
  top: "0",
  bottom: "0",
  width: "100%",
  height: "100vh",
  zIndex: 1011,
}));

export const ActionModal = styled(Box)(() => ({
  position: "fixed",
  zIndex: 1000,
  width: "300px",
  height: "250px",
  backgroundColor: Colors.white,
  borderRadius: "10px",
  padding: "10px",
  display: "flex",
  flexDirection: "column",
  right: "30%",
  alignItems: "center",
  marginLeft: " 350px",
  justifyContent: "center", // Center content vertically
  gap: "25px",
  "& .IconContain": {
    textAlign: "center",
    boxShadow: "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
    width: "75px",
    height: "75px",
    backgroundColor: Colors.white,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "-45px",
    "& svg": {
      fontSize: "45px",
      color: Colors.primary,
    },
  },
  "& .Title": {
    fontSize: "20px",
    textAlign: "center",
  },
  "& p": {
    fontSize: "12px",
    color: "gray",
  },
  "& .ButtonContain": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    letterSpacing: "1px",
    "& button": {
      border: "none",
      width: "100px",
      height: "35px",
      textAlign: "center",
      fontSize: "13px",
      "&.Delete": {
        backgroundColor: Colors.primary,
        color: Colors.white
      },
      "&.Cancel": {
        backgroundColor: Colors.white,
        color: Colors.black,
      },
    },
  },
}));
